import { render, staticRenderFns } from "./LandingBannerMiddle.vue?vue&type=template&id=353dc62a&"
import script from "./LandingBannerMiddle.vue?vue&type=script&lang=js&"
export * from "./LandingBannerMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports